import { axiosInstanceWithCredentials } from "./base";

export function getTrophies(params) {
  return axiosInstanceWithCredentials.get("/trophies", {
    params
  });
}
export function addTrophy(data) {
  return axiosInstanceWithCredentials.post(`/trophy/`,data);
}
export function getTrophy(id) {
  return axiosInstanceWithCredentials.get(`/trophy/${id}`);
}

export function updateTrophy(id,data) {
  return axiosInstanceWithCredentials.put(`/trophy/${id}`,data);
}

export function deleteTrophy(id) {
  return axiosInstanceWithCredentials.delete(`/trophy/${id}`);
}
